import { ElectricScooterCoverage } from "Store/interfaces/products/coverage";

export const ELECTRIC_SCOOTER_DEFAULT_DEDUCTIBLE = "1000";

export const getDeductible = (coverage: ElectricScooterCoverage): string => {
  if (
    coverage === ElectricScooterCoverage.ELECTRIC_SCOOTER_LIABILITY ||
    coverage ===
      ElectricScooterCoverage.ELECTRIC_SCOOTER_LIABILITY_WITH_ACCIDENT
  ) {
    return "Ingen";
  }
  return ELECTRIC_SCOOTER_DEFAULT_DEDUCTIBLE;
};
